export const CHANGE_BORING_ID1 = "CHANGE_BORING_ID1";
export const CHANGE_BORING_ID2 = "CHANGE_BORING_ID2";
export const CHANGE_YSCALE_EDITER = "CHANGE_YSCALE_EDITER";
export const CHANGE_TLIST_EDITER = "CHANGE_TLIST_EDITER";
export const CHANGE_YLIST_EDITER = "CHANGE_YLIST_EDITER";
export const CHANGE_BLIST_EDITER = "CHANGE_BLIST_EDITER";
export const CHANGE_SELROW_EDITER = "CHANGE_SELROW_EDITER";
export const CHANGE_DATA_EDITER = "CHANGE_DATA_EDITER";
export const REG_EDITER = "REG_EDITER";
export const UPDATE_WLTREDITER = "UPDATE_WLTREDITER";
export const UPDATE_POMPTREDITER = "UPDATE_POMPTREDITER";
export const CHANGE_SELMEADATA_EDITER = "CHANGE_SELMEADATA_EDITER";
export const CHANGE_SELMEAROW_EDITER = "CHANGE_SELMEAROW_EDITER";
export const CHANGE_REGMODE_EDITER = "CHANGE_REGMODE_EDITER";
export const CHANGE_MAXID_EDITER = "CHANGE_MAXID_EDITER";
export const CHANGE_USERYSCALE_EDITER = "CHANGE_USERYSCALE_EDITER";
export const CHANGE_USERTLIST_EDITER = "CHANGE_USERTLIST_EDITER";
export const CHANGE_USERYLIST_EDITER = "CHANGE_USERYLIST_EDITER";
export const CHANGE_USERBLIST_EDITER = "CHANGE_USERBLIST_EDITER";
export const UPDATE_SCREENTREDITER = "UPDATE_SCREENTREDITER";
export const CHANGE_WLSTLIST_EDITER = "CHANGE_WLSTLIST_EDITER";
export const CHANGE_WLSBLIST_EDITER = "CHANGE_WLSBLIST_EDITER";
export const CHANGE_WLSYLIST_EDITER = "CHANGE_WLSYLIST_EDITER";
export const CHANGE_WLSYSCALE_EDITER = "CHANGE_WLSYSCALE_EDITER";
export const CHANGE_DETAILCAT_EDITER = "CHANGE_DETAILCAT_EDITER";

export function changeBoringID1Action(ID) {
    return {
        type: CHANGE_BORING_ID1,
        ID: ID,
    };
}

export function changeBoringID2Action(ID) {
    return {
        type: CHANGE_BORING_ID2,
        ID: ID,
    };
}

export function changeYScaleEAction(scale) {
    return {
        type: CHANGE_YSCALE_EDITER,
        scale: scale,
    };
}

export function changeTListAction(list) {
    return {
        type: CHANGE_TLIST_EDITER,
        list: list,
    };
}

export function changeYListEAction(list) {
    return {
        type: CHANGE_YLIST_EDITER,
        list: list,
    };
}

export function changeBListEAction(list) {
    return {
        type: CHANGE_BLIST_EDITER,
        list: list,
    };
}

export function changeSelRowAction(rowID) {
    return {
        type: CHANGE_SELROW_EDITER,
        rowID: rowID,
    };
}

export function changeDataAction(isChange) {
    return {
        type: CHANGE_DATA_EDITER,
        isChange: isChange,
    };
}

export function regEditerAction(isReg) {
    return {
        type: REG_EDITER,
        isReg: isReg,
    };
}

export function updateWLTrAction(value) {
    return {
        type: UPDATE_WLTREDITER,
        value: value,
    };
}

export function updatePompTrAction(value) {
    return {
        type: UPDATE_POMPTREDITER,
        value: value,
    };
}

export function changeselMeaDataAction(value) {
    return {
        type: CHANGE_SELMEADATA_EDITER,
        value: value,
    };
}

export function changeselMeaRowAction(value) {
    return {
        type: CHANGE_SELMEAROW_EDITER,
        value: value,
    };
}

export function changeRegModeEditerAction(value) {
    return {
        type: CHANGE_REGMODE_EDITER,
        value: value,
    };
}

export function changeMaxIDEditerAction(value) {
    return {
        type: CHANGE_MAXID_EDITER,
        value: value,
    };
}

export function changeUserYScaleEAction(scale) {
    return {
        type: CHANGE_USERYSCALE_EDITER,
        scale: scale,
    };
}

export function changeUserTListAction(list) {
    return {
        type: CHANGE_USERTLIST_EDITER,
        list: list,
    };
}

export function changeUserYListEAction(list) {
    return {
        type: CHANGE_USERYLIST_EDITER,
        list: list,
    };
}

export function changeUserBListEAction(list) {
    return {
        type: CHANGE_USERBLIST_EDITER,
        list: list,
    };
}

export function updateScreenTrAction(value) {
    return {
        type: UPDATE_SCREENTREDITER,
        value: value,
    };
}

export function changeWlsTListAction(list) {
    return {
        type: CHANGE_WLSTLIST_EDITER,
        list: list,
    };
}

export function changeWlsBListEAction(list) {
    return {
        type: CHANGE_WLSBLIST_EDITER,
        list: list,
    };
}

export function changeWlsYScaleEAction(scale) {
    return {
        type: CHANGE_WLSYSCALE_EDITER,
        scale: scale,
    };
}

export function changeWlsYListEAction(list) {
    return {
        type: CHANGE_WLSYLIST_EDITER,
        list: list,
    };
}

export function changeDetailCatAction(value) {
    return {
        type: CHANGE_DETAILCAT_EDITER,
        value: value,
    };
}
